import { render, staticRenderFns } from "./AccountVoucherView.vue?vue&type=template&id=77b9e885&scoped=true&"
import script from "./AccountVoucherView.vue?vue&type=script&lang=js&"
export * from "./AccountVoucherView.vue?vue&type=script&lang=js&"
import style0 from "./AccountVoucherView.vue?vue&type=style&index=0&id=77b9e885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9e885",
  null
  
)

/* custom blocks */
import block0 from "./AccountVoucherView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports